import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

import { useTranslation } from 'modules/i18n';

import walletIcon from '../assets/wallet.png';
import translation from './connect.translation';
import { WalletModal } from './WalletModal';

export function Connect(): JSX.Element {
  const [open, setOpen] = useState(false);
  const { t, keys } = useTranslation(translation);
  const { classes } = useStyles();

  return (
    <>
      <Paper className={classes.container}>
        <img className={classes.image} src={walletIcon} alt="" />

        <Typography variant="h6" mt={6}>
          {t(keys.title)}
        </Typography>

        <Button
          data-tid="auth-open-modal-button"
          type="button"
          onClick={() => setOpen(true)}
          sx={{ mt: 8 }}
        >
          {t(keys.connect)}
        </Button>
      </Paper>

      <WalletModal onClose={() => setOpen(false)} open={open} />
    </>
  );
}

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(24, 4, 33),

    [theme.breakpoints.up('md')]: {
      margin: 'auto 0',
    },

    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(6.5),
      justifyContent: 'center',
      padding: theme.spacing(0, 4),
      minHeight: 486,
    },
  },
  image: {
    width: 119,
  },
}));
